import React from "react";
import "./Services.css";

const SERVICES = [
    {
        icon: "💡",
        title: "Lighting Supply",
        description:
            "We supply a wide range of architectural and decorative lighting products from leading European and Chinese brands, selected for quality, reliability, and value.",
    },
    {
        icon: "✏️",
        title: "Lighting Design Support",
        description:
            "Using DIALux, we deliver detailed lighting designs, including lux calculations, 3D renderings, and product optimization based on each project's needs.",
    },
    {
        icon: "🔍",
        title: "Product Consultation",
        description:
            "We help clients choose the right fixtures — balancing design intent, functionality, and budget, with full technical guidance.",
    },
    {
        icon: "⚡",
        title: "Custom LED & Linear Lighting",
        description:
            "We offer tailored LED strip and linear lighting solutions for coves, niches, shelves, and façades, ensuring seamless integration and clean finishes.",
    },
    {
        icon: "✨",
        title: "Bespoke Decorative Chandeliers",
        description:
            "We design and supply custom-made chandeliers and decorative pieces, crafted to match the interior vision and architectural theme of any space.",
    },
    {
        icon: "🏠",
        title: "Home Automation Integration",
        description:
            "We support smart lighting and automation systems, offering integration with dimming controls, motion sensors, and full home automation platforms.",
    },
    {
        icon: "🛠️",
        title: "After-Sales Support",
        description:
            "We provide reliable after-sales service, including installation advice, technical documentation, replacements, and on-site coordination if needed.",
    },
];

function Services() {
    return (
        <section id="services" className="services">
            <div className="services__container">
                <div className="section-heading">
                    <span className="section-heading__label">What We Offer</span>
                    <h2 className="section-heading__title">Our Services</h2>
                    <span className="section-heading__bar"></span>
                </div>

                <div className="services__grid">
                    {SERVICES.map((service, index) => (
                        <div className="services__card" key={index}>
                            <span className="services__card-icon">{service.icon}</span>
                            <h3 className="services__card-title">{service.title}</h3>
                            <p className="services__card-text">{service.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Services;
